<template>
    <div class="partnership_plan">
        <div class="header">
            <div class="header_box">
                <div class="header_left">
                   <div class="left_top">
                       <img src="./images/bqj.png" alt='版权登记'/>
                       <span>X</span>
                       <img src="./images/log.png" alt='版权登记'/>
                   </div>
                   <h2>著作权维权诉讼费用损失保险</h2>
                   <p>防侵权必备，让您维权无忧</p>
                   <p>仅需5元保费即可获得最高5000元赔付</p>
                   <button @click="goInsurance">马上投保</button>
                </div>
                <div class="header_right">
                    <img class="header_right_pic" src="./images/headerR.png" alt='版权登记'>
                </div>
            </div>
        </div>
        <!--    产品说明    -->
        <div class="providing_services">
            <div style="margin-bottom: -11px" class="title_big">产品说明</div>
            <div class="explain_box">
               <ul class="explain_content">
                   <li class="explain_content_list">
                       <span class="title">适用客群：</span>
                       <span class="content">通过版权家区块链存证权属证据保全的权利人   通过中国版权局登记确权的著作权权利人</span>
                   </li>
                   <li class="explain_content_list">
                       <span class="title">保险区域范围：</span>
                       <span class="content">中国大陆（除港澳台地区）</span>
                   </li>
                   <li class="explain_content_list">
                       <span class="title">保险期限：</span>
                       <span class="content">保险期间1年，可续保</span>
                   </li>
                   <li class="explain_content_list">
                       <span class="title">保险费用：</span>
                       <span class="content">5元/份</span>
                   </li>
                   <li class="explain_content_list">
                       <span class="title">累计赔偿限额：</span>
                       <span class="content">5000元，其中每次事故诉讼费用赔偿限额：3000元</span>
                   </li>
                   <li class="explain_content_list">
                       <span class="title">保障内容：</span>
                       <span class="content">保障权利人发起维权诉讼后，法院判决结果为理赔触发点，赔偿由权利人承担的诉讼费用损失。同时，承保“版权家”平台区<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;块链证据保全取证方式的有效性，如受理法院对于权属证据保全存证的方式不予采纳，则赔偿被保险人实际发生的律师费用<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;损失。</span>
                       <br/>
                       <a style="margin-left:70px;color:#F7B500;" @click="insurancePlan">保险计划详情解读>>></a>
                   </li>
                   <li class="explain_content_list">
                       <span class="title">保险条款：</span>
                       <a class="content" style="color:#F7B500;" @click="insuranceBook">《国任财产保险股份有限公司知识产权维权诉讼费用损失保险条款》</a>
                   </li>
                </ul> 
                <img src="./images/shuomingPic.png" class="smImg" alt='版权登记'/>
            </div>
            <div class="fangan">
                <p class="title">保障方案：</p>
                <ul>
                    <li>
                        <span>保障项目</span>
                        <span>保险责任简介</span>
                        <span>赔偿限额</span>
                    </li>
                    <li>
                        <span style="line-height:68px">诉讼费用</span>
                        <span style="padding:0 13px;padding-top:13px;text-align:left">在保险期间内，第三方未取得合法有效许可或授权而实施、使用投保知识产权，被保险人在保险期间内就该侵权行为向法院提起诉讼，并被法院受理的，依据最终生效的判决书判定应由被保险人承担的诉讼费用损失</span>
                        <span style="line-height:68px">3000元</span>
                    </li>
                    <li>
                        <span style="line-height:68px">律师费用</span>
                        <span style="padding:0 13px;padding-top:13px;text-align:left">法院在审理案件过程中，对于被保险人通过“北京版全家科技发展有限公司”区块链存证平台进行区块链权属证据存证的权属证据或区块链保全取证的侵权证据，受理法院对于取证方式不予认可，并以此判决被保险人起诉证据不足的，对于被保险人实际发生的律师费用损失</span>
                        <span style="line-height:68px">2000元</span>
                    </li>
                </ul>
            </div>    
        </div>
        <!--    维权案件诉讼流程    -->
        <div class="no_worries">
            <div class="container">
                <div class="title_big">维权案件诉讼流程</div>
                <div class="weiquan-box">
                    <div class="left">
                        <p class="cle-one" style="background: linear-gradient(135deg,#FFA440, #F9D519);">1</p>
                        <p style="width:468px;margin:auto;text-align:center;">拨打维权服务公司“北京版全家科技发展有限公司”客服电话17316071137，17316071136进行维权诉讼案件代理，并签订诉讼代理合同；</p>
                    </div>
                    <div class="right">
                        <p class="cle-one" style="background: linear-gradient(135deg,#14B471 , #33DF97);">2</p>
                        <p style="width:468px;margin:auto">由维权服务公司“北京版全家科技发展有限公司”为您匹配律师进行维权诉讼</p>
                    </div>
                </div>
            </div>
        </div>

        <!--    理赔流程    -->
        <div class="partnership_process">
            <div class="title_big">理赔流程</div>
            <flowChart class="partnership_process_main" :data="partnershipProcessData" boxWidth="245px" boxHeight="100px" />

        </div>

        <!--    理赔说明    -->
        <div class="users">
            <div class="title_big">理赔说明</div>
            <div class="lipei_box">
                <p>1、本保险指定维权服务公司为“北京版全家科技发展有限公司”，在保险期限内被保险人对于投保著作权进行维权诉讼的，可拨打维权服务公司“北京版全家科技发展有限公司”客服电话17316071137，17316071136进行维权诉讼案件代理；被保险人在维权过程中聘请其他维权代理机构的，保险人不承担赔偿责任。</p>
                <p>2、发生本保险合同保险责任范围内的事故后，投保人、被保险人或受益人应于知道保险事故发生之日起及时通知保险人。您可拨打国任保险客服热线：956030 进行报案，或通过“北京版全家科技发展有限公司”代为进行案件索赔；</p>
                <p>3、因投保人、被保险人的故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，我们对无法确定的部分，不承担给付保险金责任，但我们通过其他途径已经及时知道或者应当及时知道保险事故发生的除外；</p>
                <p>4、如对本保险理赔流程有任何疑问，您可拨打国任保险客服热线：956030 进行咨询。</p>
            </div>
        </div>
        <!--    常见问题    -->
        <div class="users">
            <div class="title_big">常见问题</div>
            <div class="question_box">
                <ul>
                    <li>
                        <h2>本保险产品的保障内容是什么？</h2>
                        <p>本保险保障投保著作权被保险人因第三方侵权行为向法院提起诉讼，并被法院受理的，依据最终生效的判决书判定应由被保险人承担的诉讼费用损失，以及通过“北京版全家科技发展有限公司”区块链存证平台进行区块链权属证据存证的权属证据或区块链保全取证的侵权证据，受理法院对于取证方式不予认可，并以此判决被保险人起诉证据不足的，对于被保险人实际发生的律师费用损失，对于以上责任和损失保险人在保单约定的赔偿限额内进行赔偿。具体保险保障范围以保单和条款的约定为准。</p>
                    </li>
                    <li>
                        <h2>如何查询保单？</h2>
                        <p>本保险合同采取电子保单的形式订立，电子保单与纸质保单具有同等法律效力。在您完成购买后，我们会将电子保单或电子保单下载链接发送到您在投保时所填写的手机号码。您也可以登录国任保险官方网站http://www.guorenpcic.com/进行保单的查询和验真。</p>
                    </li>
                    <li>
                        <h2>如何进行维权诉讼呢？</h2>
                        <p>本保险指定维权服务公司为“北京版全家科技发展有限公司”，在保险期限内被保险人对于投保著作权进行维权诉讼的，可拨打维权服务公司“北京版全家科技发展有限公司”客服电话17316071137，17316071136进行维权诉讼案件代理。</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 保险计划解读 -->
        <insurancePlan @fatherModal="fatherModal" v-if="showModal" ref="childModal"></insurancePlan>
    </div>
</template>

<script>
    import flowChart from '@/views/main-components/flow-chart.vue';
    import firsix from '@/views/vipClip/firstPage/components/firsix/firsix.vue'
    import {_insertCustom} from "../../../api/register";
    import {leavemessage} from '@/api/staticPage'
 import insurancePlan from './insurancePlan';
 import Cookies from "js-cookie";
    import { userInfo} from "@/api/index";

    export default {
        name: "partnershipPlan",
        components: {
            flowChart,
            firsix,
            insurancePlan
        },
        metaInfo: {
            title: '版权家版权保险|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '监测详情,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        data() {
            return {
                showModal:false,
                partnerJoiningFrom: {
                    name:'',
                    phone:'',
                    remarks:''
                }, //企业合伙人加盟表单字段
                rulePartnerJoining: {
                    name: [
                        {required: true, message: '企业名称不能为空', trigger: 'blur'},
                    ],
                    phone: [
                        {required: true, message: '联系电话不能为空', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: "联系电话格式不正确", trigger: "blur"}
                    ]
                }, //企业合伙人加盟验证规则
                partnerJoiningDisabled:false, //企业合伙人加盟提交按钮禁止事件
                partnershipProcessData: [
                    {
                        icon: require('@/views/vipClip/insurance/images/iphone.png'),
                        title: '电话报案',
                        desc: ['拨打956030报案','或通过版权家代为进行案件索赔']
                    },
                    {
                        icon: require('@/views/vipClip/insurance/images/ziliao.png'),
                        title: '准备资料',
                        desc: ['根据客服的提示', '准备并递交相关理赔材料']
                    },
                    {
                        icon: require('@/views/vipClip/insurance/images/shenhe.png'),
                        title: '资料审核',
                        desc: ['保险公司收到理赔材料后','将由理赔专员进行及时审核']
                    },
                    {
                        icon: require('@/views/vipClip/insurance/images/lipei.png'),
                        title: '理赔',
                        desc: ['通过审核后，保险公司会将理赔金','给付到您提供的被保险人指定账户上']
                    },
                    
                ], //流程图数据
            }
        },
        created() {

        },
        methods: {
            fatherModal() {
                this.showModal = false;
            },
            insurancePlan(){
                this.showModal=true
            },
            goInsurance(){
                let _this = this;
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                if(userInfo==''){
                    toast('请登录后再操作')
                    return false;
                }else{
                    _this.$router.push({
                        path:'/myInsurance'
                    })
                }
            },
            insuranceBook(){
                window.open("http://file.bqj.cn/file/ddd722eac5b0e796dad6756409ce555d.pdf", '_blank')
            },
            openChats() {
                if(typeof(_MEIQIA)!='undefined'){
                    _MEIQIA('showPanel');
                }else{
                    console.log("美洽开始初始化"+new Date().getTime());
                    (function(m, ei, q, i, a, j, s) {
                        m[i] = m[i] || function() {
                            (m[i].a = m[i].a || []).push(arguments)
                        };
                        j = ei.createElement(q),
                            s = ei.getElementsByTagName(q)[0];
                        j.async = false;
                        j.charset = 'UTF-8';
                        j.src = '//static.meiqia.com/dist/meiqia.js';
                        s.parentNode.insertBefore(j, s);
                    })(window, document, 'script', '_MEIQIA');
                    _MEIQIA('manualInit');
                    _MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
                    //隐藏美洽客服按钮
                    _MEIQIA('withoutBtn');
                    // 初始化成功时的回调
                    _MEIQIA('allSet', this.footMeiqiaCallBack);
                    //创建美洽
                    _MEIQIA('init');
                    console.log("美洽初始化结束"+new Date().getTime());
                    _MEIQIA('showPanel');
                }
            },
            partnerJoiningSubmit(){
                this.$refs['formPartnerJoining'].validate((valid) => {
                    if (valid) {
                        this.partnerJoiningDisabled = true;

                        leavemessage(this.partnerJoiningFrom).then(res => {
                            console.log(res);
                            if (res.code == 200) {
                                toast('提交成功');
                                this.partnerJoiningDisabled = false;
                                this.workName = '';
                                this.$refs['formPartnerJoining'].resetFields();
                            } else {
                                this.partnerJoiningDisabled = false;
                                toast(res.message);
                            }
                        })
                    } else {
                        this.partnerJoiningDisabled = false;

                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .container {
        width: 1334px;
        margin: 0 auto;
    }

    .title_big {
        color: #282828;
        font-size: 40px;
        line-height: 1;
        position: relative;
        z-index: 1;
        text-align: center;

        &:after {
            content: '';
            position: absolute;
            width: 64px;
            height: 64px;
            border-radius: 50%;
            left: 50%;
            background: #FFD800;
            z-index: -1;
            top: 50%;
            margin-top: -32px;
            margin-left: -32px;
        }
    }

    .partnership_plan {
        .header {
            width: 100%;
            height: 460px;
            background: url(./images/bg.png) no-repeat left center;
            background-size: cover;
            .header_box {
                width: 1334px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .header_left {
                    margin-top: 71px;
                    .left_top{
                        display:flex;
                        flex-direction:row;
                        align-items:center;
                    }
                    img{
                        width: 99px;
                        height: 35px;
                    }
                    span{
                        color: #fff;
                        display: inline-block;
                        margin: 0 11px;
                    }
                    h2{
                        font-size: 48px;
                        font-weight: 800;
                        color: #ffffff;
                        margin-top: 40px;
                        line-height: 71px;
                        margin-bottom: 11px;
                    }
                    p{
                        font-size: 20px;
                        color: #ffffff;
                        margin-top: 11px;
                        line-height: 30px;
                    }
                    button{
                        width: 144px;
                        height: 43px;
                        background: linear-gradient(135deg,#e8a644, #f6c996);
                        border-radius: 22px;
                        line-height: 43px;
                        text-align: center;
                        font-size: 18px;
                        color: #ffffff;
                        margin-top: 39px;
                        display: block;
                        border:0;
                        outline:none;
                        cursor: pointer;
                    }
                }
                .header_right {
                    width: 469px;
                    height:434px;
                    margin-top: 26px;
                    img{
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
            }
        }

        .partnership_plan_desc {
            background: #fff;
            padding: 48px 0 72px;

            .partnership_plan_desc_main {
                display: flex;
                justify-content: space-between;
                list-style: none;

                .partnership_plan_desc_main_item {
                    padding: 30px 30px 30px 32px;
                    box-shadow: 0 2px 50px 0 rgba(136, 141, 151, 0.15);
                    margin-right: 50px;
                    width: 411px;
                    box-sizing: border-box;

                    &:last-child {
                        margin-right: 0;
                    }

                    .partnership_plan_desc_main_item_img {
                        display: block;
                        width: 42px;
                        height: 42px;
                        object-fit: cover;
                    }

                    .partnership_plan_desc_main_item_title {
                        color: #282828;
                        font-size: 20px;
                        line-height: 28px;
                        padding-top: 20px;
                    }

                    .partnership_plan_desc_main_item_msg {
                        color: #666666;
                        font-size: 12px;
                        line-height: 24px;
                        padding-top: 10px;
                    }
                }
            }
        }

        .providing_services {
            // background: #F6F9FF;
            width: 1334px;
            margin: 0 auto;
            padding-top: 76px;
            margin-bottom: -4px;
            .explain_box{
                display: flex;
                justify-content: space-between;
                margin-top: 60px;
                .smImg{
                    width: 381px;
                    height: 248px;
                }
                ul{
                    li{
                        list-style: none;
                    }
                }
                .explain_content{
                    width: 832px;
                    li{
                        margin-bottom: 8px;
                        span{
                            font-size: 14px;
                            line-height: 20px;
                            
                        }
                        span:nth-of-type(1){
                            color: #666;
                        }
                        span:nth-of-type(2){
                            color: #282828;
                        }
                    }
                }
            }
            .fangan{
                .title{
                    font-size: 14px;
                    color: #666666;
                    line-height: 14px;
                    margin-bottom: 12px;
                }
                ul{
                    width: 1334px;
                    height: 179px;
                    border: 1px solid #e5e5e5;
                    li{
                        display: flex;
                        list-style: none;
                        border-bottom: 1px solid #e5e5e5;
                        span{
                            text-align: center;
                            line-height:20px ;
                        }
                        span:nth-of-type(1){
                            width: 150px;
                            border-right: 1px solid #e5e5e5;
                        }
                        span:nth-of-type(3){
                            width: 150px;
                        }
                        span:nth-of-type(2){
                           flex:1;
                           border-right: 1px solid #e5e5e5;
                        }
                    }
                    li:nth-of-type(1){
                        background:#F2F2F2 ;
                        height: 44px;
                        span{
                            line-height: 44px;
                            font-size: 16px;
                            font-weight: 600;
                            color: #282828;
                        }
                    }
                    li:nth-of-type(2){
                        height:68px;
                    }
                    li:nth-of-type(3){
                        height:68px;
                        border: none;
                    }
                }
            }
        }

        .no_worries {
            // background: #fff;
            padding: 76px 0 66px;
            .weiquan-box{
                height: 152px;
                margin-top: 60px;
            }
            .cle-one{
                width:40px;
                height:40px;
                border-radius:50%;
                line-height:40px;
                text-align:center;
                font-size: 24px;
                font-weight: 600;
                color: #ffffff;
                margin:20px auto 25px;
            }
            .left{
                width: 665px;
                height: 152px;
                background: url(./images/left.png) no-repeat left center;
                background-size: cover;
                float: left;
            }
            .right{
                 width: 669px;
                height: 152px;
                background: url(./images/right.png) no-repeat left center;
                background-size: cover;
                float: right;
            }
        }

        .partnership_process {
            padding: 76px 0 60px;

            .partnership_process_main{
                padding-top: 52px;
            }
        }
        .lipei_box{
            width: 1334px;
            margin: 60px auto 0;
            font-size: 14px;
            color: #282828;
            line-height: 28px;
        }
        .question_box{
            width: 1334px;
            margin: 60px auto 0;
            li{
                list-style: none;
                border-bottom: 1px solid #e5e5e5;
                margin-bottom: 18px;
                h2{
                    font-size: 22px;
                    font-weight: 600;
                    color: #000000;
                    margin-bottom: 12px;
                }
                p{
                    margin-bottom: 18px;
                }
            }
        }
        .users{
            background: #fff;
            padding: 76px 0 73px;

            .users_subtitle{
                color: #282828;
                font-size: 20px;
                text-align: center;
                line-height: 28px;
                padding-top: 20px;
            }
        }
    }

    @keyframes zy {

        10% {

            /*transform: rotate(15deg);*/
            transform: translate(2px);

        }

        20% {

            /*transform: rotate(-10deg);*/
            transform: translate(4px);


        }

        30% {

            /*transform: rotate(5deg);*/
            transform: translate(6px);

        }

        40% {

            /*transform: rotate(-5deg);*/
            transform: translate(8px);


        }

        50% {

            /*transform: rotate(0deg);*/
            transform: translate(10px);


        }

        60% {

            /*transform: rotate(0deg);*/
            transform: translate(8px);


        }

        70% {

            /*transform: rotate(0deg);*/
            transform: translate(6px);


        }

        80% {

            /*transform: rotate(0deg);*/
            transform: translate(4px);


        }

        90% {

            /*transform: rotate(0deg);*/
            transform: translate(2px);


        }

        100% {

            /*transform: rotate(0deg);*/
            transform: translate(0);


        }
    }

</style>